import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '@mgp/ui';

interface QA {
  q: string;
  a: string;
}

const QAS: QA[] = [
  {
    q: 'Where will my ads run?',
    a: 'Inside curated experiences chosen to fit your brand. You always know — and approve — the company you keep before anything goes live.',
  },
  {
    q: 'Is this safe for my brand?',
    a: 'Yes. Every placement is reviewed against your brand guidelines, and we maintain category and content controls so your message lands where it belongs.',
  },
  {
    q: 'How do I measure results?',
    a: 'You get a clean, shareable view of reach, engagement, and outcomes — refreshed in real time. We also help you translate those numbers into the story your team needs to tell.',
  },
  {
    q: 'How much does it cost?',
    a: 'There’s no fixed minimum. Campaigns scale from small experiments to ongoing presence — you set the budget and we plan around it.',
  },
  {
    q: 'How long does it take to launch?',
    a: 'A first conversation typically becomes a live campaign within a few days. Faster if you have your creative ready; longer if you’d like us to help shape it.',
  },
  {
    q: 'Can I pause or change direction?',
    a: 'Anytime. Adjust budget, switch creative, or pause entirely from your dashboard — no contracts, no awkward calls.',
  },
];

export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section id="faq" className="border-t border-border-soft">
      <div className="mx-auto max-w-3xl px-4 py-24 sm:px-6 lg:px-8 lg:py-32">
        <div className="text-center">
          <span className="text-xs font-semibold uppercase tracking-caps text-primary">
            Questions, answered
          </span>
          <h2 className="mt-3 font-display text-4xl leading-display tracking-display text-ink sm:text-5xl">
            Everything you’d want to know upfront.
          </h2>
        </div>

        <ul className="mt-14 divide-y divide-border-soft border-y border-border-soft">
          {QAS.map((qa, idx) => {
            const isOpen = open === idx;
            return (
              <li key={qa.q}>
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : idx)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 py-6 text-left transition-colors duration-fast hover:text-primary"
                >
                  <span className="text-lg font-medium text-ink sm:text-xl">{qa.q}</span>
                  <ChevronDown
                    aria-hidden
                    className={cn(
                      'h-6 w-6 shrink-0 text-ink-muted transition-transform duration-base',
                      isOpen && 'rotate-180 text-primary',
                    )}
                  />
                </button>
                {isOpen ? (
                  <p className="pb-6 pr-10 text-base leading-body text-ink-secondary sm:text-lg">
                    {qa.a}
                  </p>
                ) : null}
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
